
export class UpgradeBookingContext {
    public routeTo: string[] = []
    public nextTo: string = ""

    constructor() { }
} 